module.exports = __webpack_public_path__ + "img/testimoni-bapak-alisaaf-baituna.3fe8aadd.jpeg";